<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="券码:">
              <el-input v-model.trim="formInlineTmp.code" placeholder="" clearable></el-input>
            </el-form-item>
            <el-form-item label="领取人:">
              <el-input v-model.trim="formInlineTmp.use_name" placeholder="" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号:">
              <el-input v-model.trim="formInlineTmp.use_phone" placeholder="" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="approveAction" class="add-btn btn-right" style="float: right;">审核</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData" v-loading="loading" class="table" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :selectable='selectable' prop="id">
        </el-table-column>
        <el-table-column label="券码" width="300">
          <template slot-scope="scope">
            {{ scope.row.code }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="领取时间">
          <template slot-scope="scope">
            {{ scope.row.receive_time }}
          </template>
        </el-table-column>
        <el-table-column label="领取人">
          <template slot-scope="scope">
            {{ scope.row.use_name }}
          </template>
        </el-table-column>
        <el-table-column label="领取人手机号">
          <template slot-scope="scope">
          {{ scope.row.use_phone }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0" style="color: orange;font-size:12px">未领取</span>
            <span v-if="scope.row.status === 10" style="color: #05B324;font-size:12px">未使用</span>
            <span v-if="scope.row.status === 20" style="color: #FF2B2B;font-size:12px">已使用</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.reviewed === 0" style="color: orange;font-size:12px">未审核</span>
            <span v-if="scope.row.reviewed === 1" style="color: #05B324;font-size:12px">已审核</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.reviewed === 0" class="op-link" @click="approveCoupons(scope.row.id)">
              审核
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getCouponCodesApprovelist, couponCodesApprove } from '@/api/yunzhong.js'
export default {
  name: 'list',
  data() {
    return {
      loading: true,
      hide: true,
      statusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '未领取',
          value: '1'
        },
        {
          label: '未使用',
          value: '2'
        },
        {
          label: '已使用',
          value: '3'
        }
      ],
      tableData: [],
      page: 1,
      totalCount: 0,
      formInlineTmp: {},
      formInline: {},
      limit: 10,
      multipleSelection:[]
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    selectable(row,index) {
      if(row.reviewed===0){
        return true
      }else {
        return false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      //console.log(this.multipleSelection)
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      //console.log('handleCurrentChangethis.formInline', this.formInline)
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getCouponCodesApprovelist(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    approveCoupons(ids){
      this.$confirm('确认要审核选中的优惠券?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        couponCodesApprove(ids).then((res) => {
          console.log(res)
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    approveAction(){
      var ids = this.multipleSelection.map(item => item.id).toString()
      //console.log(ids)
      this.approveCoupons(ids)
    }
  },
  created() {
    this.getData()
  },
  components: {}
}
</script>
<style scoped>
.sign-manage-title {
  height: 40px;
}

.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}

.content-one p {
  text-align: left;
}
</style>
